module.exports = __webpack_public_path__ + "img/off_normal.54ab4731.png";